import { backendApi } from "@api/base/backend";

export async function fetchChats() {
  const data = await backendApi.callApi(
    "/chat", "GET", undefined, {}, {
      lsCached: true,
      lsCacheTTL: 5 * 60 * 1000,
    }
  );

  return { data };
}

export async function createChat(message: string) {
  const data = await backendApi.callApi(
    "/chat",
    "POST",
    JSON.stringify({
      "message": message,
    })
  );

  return { data };
}

export async function fetchChatDetails(
  chat_uuid: string,
  offset: number = 0,
  limit: number = 100,
) {
  const data = await backendApi.callApi(
    `/chat/${chat_uuid}?offset=${offset}&limit=${limit}`,
    "GET", undefined, {}, {
      lsCached: true,
      lsCacheTTL: 60 * 1000,
    }
  );

  return { data };
}

export async function fetchDownloadLink(chat_uuid: string) {
  const data = await backendApi.callApi(
    `/chat/${chat_uuid}/download`,
    "GET"
  );

  return { data };
}

